const decodeHtmlEntities = (str: string): string => {
  const entities: { [key: string]: string } = {
    "&amp;": "&",
    "&lt;": "<",
    "&gt;": ">",
    "&quot;": '"',
    "&apos;": "'",
    "&nbsp;": " ",
    "&ldquo;": "“",
    "&rdquo;": "”",
  }
  return str.replace(/&[a-z]+;/gi, (entity) => entities[entity] || entity)
}

export const cleanTitle = (title = ""): string => {
  if (typeof title !== "string") return ""

  const stripHtmlRegex = /<\/?[^>]+(>|$)/g
  const stripCharsRegex = /[^\w\s-]/gi
  const stripFirstNo = /[\d]*[.]/i

  const cleanedTitle = decodeHtmlEntities(title)
    .replace(stripHtmlRegex, "-")
    .toLowerCase()
    .replace(/ /g, "-")
    .replace(stripFirstNo, "")
    .replace(stripCharsRegex, "")
    .replace(/---/g, "-")
    .replace(/--/g, "-")

  if (cleanedTitle.startsWith("-")) {
    return cleanedTitle.replace("-", "")
  }
  return cleanedTitle
}
